if (!customElements.get('wlsn-faqs')) {
  class WLSNFAQs extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        tabButton: 'js-wlsn-faq-tab-button',
        tabContent: 'js-wlsn-faq-tab-content',
        tabsContainer: 'js-wlsn-faqs-tabs-container',
      };
    }

    /**
     * Get DOM elements
     * @returns {object} - Object containing DOM element references
     */
    get elements() {
      return {
        tabsContainer: this.querySelector(`.${this.classes.tabsContainer}`),
        tabButtons: this.querySelectorAll(`.${this.classes.tabButton}`),
        tabContents: this.querySelectorAll(`.${this.classes.tabContent}`),
      };
    }

    /**
     * Connected callback lifecycle method
     * @returns {void}
     */
    connectedCallback() {
      this._organizeTabs();
    }

    /**
     * Disconnected callback lifecycle method
     * @returns {void}
     */
    disconnectedCallback() {
      this.elements.tabButtons.forEach((button) => button.removeEventListener('click', this._handleTabClick.bind(this)));
    }

    /**
     * Organize tabs by moving buttons to container and setting up event listeners
     * @returns {void}
     */
    _organizeTabs() {
      const { tabsContainer, tabButtons, tabContents } = this.elements;
      if (!tabsContainer) return;

      // Move all tab buttons to the aside container
      tabButtons.forEach((button, index) => {
        button.dataset.tabIndex = index + 1;

        // First tab is active by default
        if (index === 0) {
          button.classList.add(this.classes.active);
        }

        // Move button to the aside
        tabsContainer.appendChild(button);

        // Add event listener
        button.addEventListener('click', this._handleTabClick.bind(this));
      });

      // Set tab content visibility
      tabContents.forEach((content, index) => {
        content.dataset.tabIndex = index + 1;

        // First content is visible by default
        if (index === 0) {
          content.classList.add(this.classes.active);
        }
      });
    }

    /**
     * Handle tab click event
     * @param {Event} event - The click event
     * @returns {void}
     */
    _handleTabClick(event) {
      const target = event.currentTarget;
      const tabIndex = target.dataset.tabIndex;
      const tabContent = this.elements.tabContents[tabIndex - 1];

      if (!tabContent) return;

      // Remove active class from all tabs and content
      this.elements.tabButtons.forEach((button) => button.classList.remove(this.classes.active));
      this.elements.tabContents.forEach((content) => content.classList.remove(this.classes.active));

      // Add active class to the clicked tab and corresponding content
      target.classList.add(this.classes.active);
      tabContent.classList.add(this.classes.active);
    }
  }
  customElements.define('wlsn-faqs', WLSNFAQs);
}
